module.exports = __webpack_public_path__ + "img/td.a5bcfd6e.svg";